import { render, staticRenderFns } from "./HomepageWidget.vue?vue&type=template&id=91e362a0"
import script from "./HomepageWidget.vue?vue&type=script&lang=js"
export * from "./HomepageWidget.vue?vue&type=script&lang=js"
import style0 from "./HomepageWidget.vue?vue&type=style&index=0&id=91e362a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports